import * as React from 'react'

import { Box, Button, useToggle } from '@factorialco/deprecated-design-system'
import { PerformanceTargetAvatarFragment } from 'generated/resources/graphql'

import { DeleteTargetModal } from './TargetModals/DeleteTargetModal'

export const Actions: React.FC<{
  processTargetId: string
  targetAccess: PerformanceTargetAvatarFragment
}> = ({ targetAccess, processTargetId }) => {
  const [showDeleteTargetModal, toggleDeleteTargetModal] = useToggle()
  return (
    <Box flexDirection="row" gap="s8" justifyContent="flexEnd">
      <Button
        type="secondary"
        aria-label="Delete target from review"
        onClick={toggleDeleteTargetModal(true)}
        iconName="delete"
      />
      {showDeleteTargetModal && (
        <DeleteTargetModal
          targetAccess={targetAccess}
          onClose={toggleDeleteTargetModal(false)}
          processTargetId={processTargetId}
        />
      )}
    </Box>
  )
}
